/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetRegistrationSiteResult } from '../../models/get-registration-site-result';

export interface GetSite$Params {
  SiteName?: string;
}

export function getSite(
  http: HttpClient,
  rootUrl: string,
  params?: GetSite$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetRegistrationSiteResult>> {
  const rb = new RequestBuilder(rootUrl, getSite.PATH, 'get');
  if (params) {
    rb.query('SiteName', params.SiteName, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetRegistrationSiteResult>;
    }),
  );
}

getSite.PATH = '/Registration/site';
